import { ContainerFluid } from '../../components';
import DesignBrand from './design-brand';
import DesignBrandBook from './design-brand-book';
import DesignContact from './design-contact';
import styles from './design-contact.module.css';
import DesignIllustrations from './design-illustrations';
import DesignIntro from './design-intro';
import DesignPrototype from './design-prototype';
import DesignQuote from './design-quote';
import DesignSketching from './design-sketching';
import DesignVisual from './design-visual';
import DesignWireframing from './design-wireframing';

export default function DesignPage() {
  return (
    <ContainerFluid>
      <DesignIntro />
      <DesignQuote />
      <DesignSketching />
      <DesignWireframing />
      <DesignBrand />
      <DesignBrandBook />
      <DesignVisual />
      <DesignPrototype />
      <DesignIllustrations />
      <DesignContact
        title={<h2 className={styles.form_title}>Got a project in mind?</h2>}
      />
    </ContainerFluid>
  );
}
